const Menu = [
  { 
  	path: '/', icon: 'fa fa-th', title: 'Inicio'
  },
    { 
  	path: '/usuarios', icon: 'fa fa-address-book', title: 'Usuarios'
  },
  { 
  	path: '/notificacionesBoletin', icon: 'fa fa-bell', title: 'Notificaciones'
  },/*
  { 
  	path: '/reporte', icon: 'fa fa-book', title: 'Reportes'
  }, */
  { 
  	path: '/catalogos', icon: 'fa fa-database', title: 'Catálogos'
  },
  { 
  	path: '/Metas', 
    icon: 'fa fa-flag-checkered', 
    title: 'Metas',
    children: [
      { path: "/Metas/Metas-POA", title: "Lista" },
      { path: "/Metas/visualizacion-reportes-poa", title: "Visualización de reportes" },
    ],
  },
  { 
  	path: '/reportes-main', icon: 'fa fa-table', title: 'Reportes'
  },
  
]

export default Menu;
